




























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyList from "@/mixins/list";

import NoteAdd from "./note_add.vue";

@Component({
  components: {
    NoteAdd
  }
})
export default class extends Mixins(MyList) {
  // @Prop() subjectId!: number
  @Prop() editData!: any;

  @Prop() stadiumId!: number;

  data: any[] = [];

  attachments: string[] = [];

  listloading = false;

  async mounted() {
    this.loadData();
  }

  async loadData() {
    this.listloading = true;
    const res = await this.$store.dispatch("stadium/notes", {
      stadium_id: this.stadiumId
    });
    if (res && res.Message && res.Message === "success") {
      // console.log(res)
      this.data = res.Data || [];
    }
    this.listloading = false;
  }

  handleCancel1() {
    this.addModalVisible = false;
    this.loadData();
  }
}
